module.exports = __webpack_public_path__ + "static/img/wdzt1-2.5d4bb8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-2.png
// module id = 849
// module chunks = 0